import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-committee',
  templateUrl: './committee.component.html',
  styleUrls: ['./committee.component.css']
})
export class CommitteeComponent implements OnInit {
  listPro = []; listProvote; voteId; listSR = []; listChain = []; SrPro: any = {}; token = localStorage.getItem('Sastana_Token'); modalRef: BsModalRef;
  @ViewChild('beforeLogin') beforeLogin: TemplateRef<any>;
  @ViewChild('srForm') srForm: TemplateRef<any>;
  @ViewChild('appsrForm') appsrForm: TemplateRef<any>;
  @ViewChild('proposalForm') proposalForm: TemplateRef<any>;
  @ViewChild('voteForm') voteForm: TemplateRef<any>;
  chaintot: number = 1; tot: number = 1; signLoader = false;

    constructor(private conn: ConnectionService, private modalService: BsModalService, private alert: ToastrService, private route: Router) { }

  ngOnInit() {
    this.conn.changebackground();
    this.getContract();
    this.getSRStatus();
    this.getSR();
  }


  getContract() {
    this.conn.getUrl('proposal/listProposal').subscribe((res: any) => {
      this.listChain = res.chain;
      for (var k = 0; k < this.listChain.length; k++) {
        this.listChain[k].position = k + 1;
      }
      this.listPro = res.result;
      for (var j = 0; j < this.listPro.length; j++) {
        this.listPro[j].position = j + 1;
      }
    });
  }

  getSRStatus() {
    this.conn.postRequest('proposal/SRStatus', '', this.token).subscribe((res: any) => {
      if (res.status == true) {
        this.SrPro = res.result;
        if (this.SrPro != '{}' && this.SrPro.is_witness) {
          this.SrPro.is_witness = res.result.is_witness
        }
      } else {
        this.SrPro.is_witness = false;
      }
    });
  }

  getSR() {
    this.conn.getUrl('proposal/listSuperRepresentatives').subscribe((res: any) => {
      this.listSR = res.result;
      for (var j = 0; j < this.listSR.length; j++) {
        this.listSR[j].position = j + 1;
      }
    });
    this.conn.clearbackground();
  }

  sendModal() {
    this.modalRef = this.modalService.show(this.srForm);
  }

  voteModal(voteId) {
    this.voteId = voteId;
    this.modalRef = this.modalService.show(this.voteForm);
  }

  loginModal() {
    this.modalRef = this.modalService.show(this.beforeLogin);
  }

  SRModal() {
    this.modalRef = this.modalService.show(this.appsrForm);
  }

  proModal() {
    this.modalRef = this.modalService.show(this.proposalForm);
  }

  applySRFunc(appsrForm: NgForm) {
    var data = appsrForm.value;
    this.conn.postRequest('proposal/applyForSR', data, this.token).subscribe((res: any) => {
      this.signLoader = true;
      if (res.status == true) {
        this.alert.success(res.msg, "Success");
        this.SrPro.is_witness = true;
      } else {
        this.alert.error(res.msg, "Warning");
      }
      this.signLoader = false;
      this.modalRef.hide();
      this.route.navigate(['/representatives']);
      // window.location.reload();
    });
  }

  createProposal(proposal: NgForm) {
    var data = proposal.value;
    this.conn.postRequest('proposal/createProposal', data, this.token).subscribe((res: any) => {
      this.signLoader = true;
      if (res.status == true) {
        this.alert.success(res.msg, "Success");
        this.getContract();
      } else {
        this.alert.error(res.msg, "Warning");
      }
      this.modalRef.hide();
      this.signLoader = false;
    });
  }

  voteProposal(votePro: NgForm) {
    var data = votePro.value;
    data['proId'] = this.voteId;
    this.signLoader = true;
    this.conn.postRequest('proposal/voteProposal', data, this.token).subscribe((res: any) => {
      if (res.status == true) {
        this.alert.success(res.msg, "Success");
        this.getContract();
      } else {
        this.alert.error(res.msg, "Warning");
      }
      this.modalRef.hide();
      this.signLoader = false;
    });
  }

}


